import script from "./InputTextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputTextField.vue?vue&type=script&setup=true&lang=ts"

import "./InputTextField.vue?vue&type=style&index=0&id=37565377&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37565377"]])

export default __exports__